import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { DOC_EXPIRATION_SETTINGS_ACTION_TYPE } from '../actions';

const initialState = {};

const documentExpirationSettings = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case DOC_EXPIRATION_SETTINGS_ACTION_TYPE.GET_SETTINGS:
        return payload || initialState;

      case DOC_EXPIRATION_SETTINGS_ACTION_TYPE.EDIT_SETTING:
        draft[payload.documentExpirationDateType] = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default documentExpirationSettings;
